"use client";

import { VoteCard } from "./vote-card";
import { toast } from "sonner";
import AnimatedHeading from "../ui/animatedHeading";
import NoData from "../ui/noData";
import CardSkeleton from "../ui/cardSkeleton";
import { useCatDev } from "@/context/catdevContext";

export default function VoteList() {
  const { votingData, tokenData, isVotes, setIsVotes, setVotingData, isLoading } = useCatDev();
  
  const handleVote = async (tokenId: string, name: string) => {
    try {
      const response = await fetch(
        "https://api.catdevai.com/api/update-vote-new/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.log(errorData);
        toast.error(errorData.error);
        return;
      }

      const data = await response.json();
      toast.success(data.message);

      // Update voting data
      setVotingData((prev) =>
        prev.map((item) => {
          if (item.name === name) {
            // Increase vote for newly selected token
            return { ...item, vote: item.vote + 1 };
          }
          if (item.name === isVotes.name) {
            // Decrease vote for previously selected token
            return { ...item, vote: Math.max(0, item.vote - 1) };
          }
          return item;
        })
      );

      // Update voting status
      setIsVotes({
        voted: true,
        name: name,
      });
    } catch (error) {
      console.error("Error updating vote:", error);
      toast.error("Failed to update vote");
    }
  };

  return (
    <section id="votelist" className="py-20 px-4">
      <div className="text-center w-full sm:w-[70%] mx-auto sm:mb-12 space-y-2 max-w-screen-sm">
        <h2 className="text-base font-semibold text-slate-600">
          Dive into the world of Cat and vote for your favorites.
        </h2>

        <AnimatedHeading
          as="p"
          playOnView
          splitText
          delayStep={0.15}
          duration={0.3}
          className="mb-12 mt-16 text-indigo-500"
        >
          Together we will build Artificial Super Catteligence
        </AnimatedHeading>
      </div>
      {isLoading && (
        <div className="flex justify-center ">
          < CardSkeleton type="vote" count={3} />
        </div>
      )}
      <div className="container mx-auto ">
        <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-x-1 gap-y-1 max-w-6xl mx-auto place-items-center">
          {/* {votesData.map((item) => (
                        <VoteCard
                            key={item.id}
                            imageSrc={item.imageSrc}
                            content={item.content}
                            votes={item.votes}
                            name={item.name}
                            onVote={() => handleVote(`cat${item.id}` as keyof typeof votes)}
                        />
                    ))} */}

          {tokenData?.map((item, index) => {
            const voteInfo = votingData.find((v) => v.name === item.name);
            return (
              <VoteCard
                key={voteInfo?.token_id || index}
                imageSrc={item.url}
                content={item.description}
                votes={voteInfo?.vote || 0}
                name={item.name}
                onVote={() => handleVote(voteInfo?.token_id || "", item.name)}
                isVoted={isVotes.voted}
                votedName={isVotes.name}
              />
            );
          })}
          {!isLoading && tokenData.length === 0 && (
            <NoData
              title="No data available."
              description="Currently no data available please try again later!"
            />
          )}
        </div>
      </div>
    </section>
  );
}
